import { emitBootstrapTracking, readTracking } from '@actions/tracking';
import Loading from '@components/Loading';
import { initCatalog } from '@core/catalog';
import { readFormQueryParams, resolveFormQueryParams } from '@core/queryParams';
import { FC, useEffect, useState } from 'react';
import { getThemes } from './api';
import Error from './pages/Error';
import Form from './pages/Form';
import MultiStepFormContextProvider from './pages/Form/context/Provider';

type Status = 'loading' | 'success' | 'error';

interface Props {
  isIpac: boolean;
}

const App: FC<Props> = ({ isIpac }) => {
  const [status, setStatus] = useState<Status>('loading');

  useEffect(() => {
    const loadThemes = async () => {
      const result = await getThemes();
      if (result.success) {
        const themes = result.data;
        const formQueryParams = resolveFormQueryParams({
          formQueryParams: readFormQueryParams(),
          themes,
        });
        const tracking = readTracking();

        initCatalog({ isIpac, themes, formQueryParams, tracking });
        emitBootstrapTracking({
          tracking,
          themes,
          idFormationBitrix: formQueryParams.idFormationBitrix,
        });
        setStatus('success');
      } else {
        setStatus('error');
      }
    };

    loadThemes();
  }, [isIpac]);

  if (status === 'loading') {
    return <Loading />;
  }

  if (status === 'error') {
    return <Error />;
  }

  return (
    <MultiStepFormContextProvider>
      <Form />
    </MultiStepFormContextProvider>
  );
};

export default App;
